import React, {Component} from 'react';
import {ElementGroup, Indent, Justify} from '@pb/kit-component-element-group';
import {TypedInput, ValidType} from '@pb/kit-component-input-v2';
import {Label} from '@pb/kit-component-label';
import {hashedClasses} from '@pb/kit-util-with-css-module';
import {uniqId} from '../utils/uniqId';

import styles from './go-to-page.component.module.styl';

const classes = hashedClasses(styles);

export const GO_TO_CAPTION = 'Go To';

type State = {
    pageNumber: string,
};

type Props = {
    onChange: (page: number, entryPoint: string) => void,
};

export class GoToPage extends Component<Props, State> {
    state = {
        pageNumber: '',
    };

    shouldComponentUpdate(nextProps: Props, nextState: State) {
        return this.state.pageNumber !== nextState.pageNumber;
    }

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({pageNumber: event.target.value});
    };

    onPageChange = () => {
        const page = Number(this.state.pageNumber.replace(/\s/g, ''));
        if (page && !isNaN(page)) {
            this.props.onChange(page, GO_TO_CAPTION);
            this.setState({pageNumber: ''});
        }
    };

    onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            this.onPageChange();
            event.preventDefault();
        }
    };

    render() {
        const id = uniqId();

        return (
            <ElementGroup justify={Justify.CENTER} indent={Indent.S} mix="pagination__go-to-page go-to-page">
                <Label
                    htmlFor={id}
                    ellipsis={false}
                    rootProps={{className: classes['go-to-page__label-root']}}
                    className={classes['go-to-page__label']}>
                    Go To
                </Label>
                <TypedInput
                    id={id}
                    value={this.state.pageNumber}
                    placeholder="Page"
                    rootProps={{className: classes['go-to-page__page-number']}}
                    className={classes['go-to-page__text-align']}
                    onChange={this.onChange}
                    onBlur={this.onPageChange}
                    onKeyDown={this.onKeyDown}
                    validateType={ValidType.INT_POSITIVE}
                    aria-label="Page number"
                />
            </ElementGroup>
        );
    }
}
